import React, { useContext, useEffect, useMemo } from 'react';
import WorkspaceContext from '../Context/WorkspaceContext';
import ViewContext from '../Context/ViewContext';
import FiltersContainer from '../view/FiltersContainer';

/**
 * Workspace filters component - Allows adding/removing/updating of filters on the workspace.
 */
const GridToolbarWorkspaceFiltersContainer = ({
  tabEnable = true,
  preventSelectionResetOnFilterChange = false,
}: {
  tabEnable?: boolean;
  preventSelectionResetOnFilterChange?: boolean;
}) => {
  const { viewScreenName, availableColumns, currentView } = useContext(ViewContext);
  const { availableFiltersFilter } = useContext(WorkspaceContext);

  const filteredAvailableColumns = useMemo(() => {
    const filtered =
      availableColumns && availableFiltersFilter ? availableColumns.filter(availableFiltersFilter) : availableColumns;
    return filtered ?? [];
  }, [availableColumns, availableFiltersFilter]);

  if (!currentView) {
    return null;
  }
  return (
    <FiltersContainer
      tabIndex={tabEnable ? 1 : -1}
      availableColumns={filteredAvailableColumns}
      screenName={viewScreenName}
      preventSelectionResetOnFilterChange={preventSelectionResetOnFilterChange}
    />
  );
};

export default GridToolbarWorkspaceFiltersContainer;
